//
// Imports
//

import * as BrowserUtilities from "@donutteam/browser-utilities";

import * as UserPreferenceClientLib from "../../../_shared/libs/client/UserPreference.client.js";

import * as UserPreferenceSchemaLib from "../../../_shared/libs/schemas/UserPreference.js";

//
// Locals
//

async function initialise(form: HTMLElement)
{
	const apiUrl = BrowserUtilities.ElementClientLib.getStringDataOrThrow(form, "apiUrl");

	form.addEventListener("submit", (event) => event.preventDefault());

	const defaultMarkupTypeSelect = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLInputElement>(form, `select[name="global::default_markup_type"]`);

	defaultMarkupTypeSelect.addEventListener("change", 
		() =>
		{
			const defaultMarkupType = UserPreferenceSchemaLib.StoreSchema.shape["global::default_markup_type"].parse(defaultMarkupTypeSelect.value);

			UserPreferenceClientLib.updateValue(apiUrl, defaultMarkupTypeSelect, "global::default_markup_type", defaultMarkupType);
		});
}

//
// Component
//

export async function initialiseGeneralPreferencesForms()
{
	const generalPreferencesForms = document.querySelectorAll<HTMLFormElement>(".component-general-preferences-form:not(.initialised)");

	for (const form of generalPreferencesForms)
	{
		try
		{
			await initialise(form);

			form.classList.add("initialised");
		}
		catch (error)
		{
			console.error("[DesignPreferencesForm] Error initialising:", form, error);
		}
	}
}